// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint, cartPageTemplateStyles } from "@keller/App/Components/Cart/CartPageTemplate";
import { DivWrapper } from "@keller/XDL/constants";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

cartPageTemplateStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr minmax(0, 290px);
        grid-column-gap: 40px;
        ${xScreen("lte", "md")} {
            grid-column-gap: 16px;
        }
    `,
};

cartPageTemplateStyles.headerSection = {
    css: css`
        grid-row: 1/2;
        grid-column: 1/3;

        h1 {
            margin-bottom: 24px;
        }
    `,
};

cartPageTemplateStyles.actionsSection = {
    css: css`
        grid-row: 4/5;
        ${xScreen("lte", "sm")} {
            grid-column: 1/3;
        }
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-row: 3/4;
            grid-column: 1/3;
        }
        ${xScreen("lte", "xs")} {
            grid-row: 4/5;
        }
    `,
};

cartPageTemplateStyles.fulfillmentMethodSection = {
    css: css`
        grid-row: 2/3;
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1/3;
            margin-bottom: 12px;
        }
    `,
};

cartPageTemplateStyles.mainSection = {
    css: css`
        grid-row: 3/4;
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1/3;
            grid-row: 4/5;
        }
    `,
};

cartPageTemplateStyles.totalSection = {
    css: css`
        grid-row: 2/5;

        // XNG-Sticky
        & > div.xng-sticky > ${DivWrapper} > div:not(:last-child) {
            margin-bottom: 20px;
        }
        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-row: 5/6;
            grid-column: 1/3;
            margin-top: 38px;
            margin-left: auto;
            margin-right: auto;
            & > div.xng-sticky {
                max-width: 100%;
            }

            & > div.xng-sticky {
                max-width: 300px;
            }
        }
        ${xScreen("lte", "xs")} {
            & > div.xng-sticky {
                max-width: 100%;
            }
        }
    `,
};
